import { cn } from "@/lib/utils";
import { RESOURCE_GROUPS, RESOURCE_LABELS, type ActivityResource } from "./activityResources";
import { RelativeTime } from "./RelativeTime";

export interface ResourceTile {
  count: number;
  lastCreatedAt?: string | null;
}

/** All-time record counts, grouped by ledger area. Shared by the Stats tab and the Analytics views. */
export function ResourceTotalsGrid({
  totals,
  className,
}: {
  totals: Partial<Record<ActivityResource, ResourceTile>>;
  className?: string;
}) {
  return (
    <div className={cn("space-y-3", className)}>
      {RESOURCE_GROUPS.map((group) => (
        <section key={group.label} className="grid grid-cols-[6.5rem_1fr] items-start gap-3">
          <h3 className="text-muted-foreground pt-3 text-xs font-medium uppercase tracking-wider">{group.label}</h3>
          <dl className="grid grid-cols-2 gap-2 sm:grid-cols-3 xl:grid-cols-5">
            {group.resources.map((resource) => {
              const tile = totals[resource];
              const count = tile?.count ?? 0;
              return (
                <div key={resource} className="min-w-0 rounded-md border px-3 py-2.5">
                  <dt className="text-muted-foreground truncate text-xs">{RESOURCE_LABELS[resource]}</dt>
                  <dd className={cn("mt-0.5 text-xl font-semibold tabular-nums", count === 0 && "text-muted-foreground")}>
                    {count.toLocaleString("en-GB")}
                  </dd>
                  {tile?.lastCreatedAt !== undefined && (
                    <dd className="text-muted-foreground mt-0.5 truncate text-[11px]">
                      {tile.lastCreatedAt ? <RelativeTime value={tile.lastCreatedAt} prefix="Last created " /> : "None yet"}
                    </dd>
                  )}
                </div>
              );
            })}
          </dl>
        </section>
      ))}
    </div>
  );
}
